var _g, _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssessmentSent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 130,
    viewBox: "0 0 131 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10601_8543)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.477,
    y: 31.059,
    width: 49.78,
    height: 67.3087,
    rx: 3.4,
    stroke: "#333333",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7646 60.6697H47.0246C46.7678 60.6697 46.5605 60.4634 46.5605 60.2079C46.5605 59.9524 46.7678 59.7461 47.0246 59.7461H64.7646C65.0214 59.7461 65.2287 59.9524 65.2287 60.2079C65.2287 60.4634 65.0214 60.6697 64.7646 60.6697Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7646 83.6423H47.0246C46.7678 83.6423 46.5605 83.4361 46.5605 83.1805C46.5605 82.925 46.7678 82.7188 47.0246 82.7188H64.7646C65.0214 82.7188 65.2287 82.925 65.2287 83.1805C65.2287 83.4361 65.0214 83.6423 64.7646 83.6423Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7646 72.7253H47.0246C46.7678 72.7253 46.5605 72.5191 46.5605 72.2636C46.5605 72.008 46.7678 71.8018 47.0246 71.8018H64.7646C65.0214 71.8018 65.2287 72.008 65.2287 72.2636C65.2287 72.5191 65.0214 72.7253 64.7646 72.7253Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6055 39.5361H79.4335C80.2619 39.5361 80.9335 40.2077 80.9335 41.0361V46.6137C80.9335 47.4422 80.2619 48.1137 79.4335 48.1137H46.6055C45.777 48.1137 45.1055 47.4422 45.1055 46.6137V41.0361C45.1055 40.2077 45.777 39.5361 46.6055 39.5361Z",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8086 53.1133H79.4335C80.2619 53.1133 80.9335 53.7849 80.9335 54.6133V60.1909C80.9335 61.0193 80.2619 61.6909 79.4335 61.6909H73.8086C72.9802 61.6909 72.3086 61.0193 72.3086 60.1909V54.6133C72.3086 53.7849 72.9802 53.1133 73.8086 53.1133Z",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8086 66.6914H79.4335C80.2619 66.6914 80.9335 67.363 80.9335 68.1914V73.769C80.9335 74.5974 80.2619 75.269 79.4335 75.269H73.8086C72.9802 75.269 72.3086 74.5974 72.3086 73.769V68.1914C72.3086 67.363 72.9802 66.6914 73.8086 66.6914Z",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8086 80.2695H79.4335C80.2619 80.2695 80.9335 80.9411 80.9335 81.7695V87.3471C80.9335 88.1756 80.2619 88.8471 79.4335 88.8471H73.8086C72.9802 88.8471 72.3086 88.1756 72.3086 87.3471V81.7695C72.3086 80.9411 72.9802 80.2695 73.8086 80.2695Z",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.647 29.5288C32.5652 27.3629 34.2233 25.5259 36.3863 25.3862L80.6757 22.5251C82.9815 22.3761 84.9336 24.2061 84.9336 26.5167V89.8552C84.9336 92.0644 83.1427 93.8552 80.9336 93.8552H60.0051H38.9284C36.778 93.8552 35.0124 92.1551 34.9313 90.0062L32.647 29.5288Z",
    fill: "#763FE3",
    fillOpacity: 0.12
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.4143,
    cy: 88.9143,
    r: 19.3143,
    fill: "#C1E498",
    stroke: "black",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.5684 90.4612L82.4005 95.0005L91.2594 86.1416",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10601_8543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 77,
    fill: "white",
    transform: "translate(32.5 22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentSent);
export default __webpack_public_path__ + "static/media/assessment-sent.fe1565442a2a8fbc3fd6d3c96622fa67.svg";
export { ForwardRef as ReactComponent };